export const KeyAttributesListStyle = {
  
  card: {
    marginTop: '32px',
    position: 'relative',
  },

  cardDisabled: {
    backgroundColor: '#F3F4F6',
    pointerEvents: 'none',
  },

  cardHeader: {
    padding: '24px 24px',
  },

  cardContent: {
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop: '4px',
  },

  list: {
    padding: '0px',
  },

  headerBox: {
    display: 'flex',
    alignItems: 'center',
  },

  itemsCounterWrapper: {
    marginLeft: 'auto',
    marginRight: '40px',
  },
} as const;
